import { type Channel } from './ChannelMatrixRow'

// <thead> for the By Channel matrix: one column per sales channel. On a
// revision the row labels (ChannelMatrixRow) name the quarters, so the
// channel name stands alone. Extracted from ChannelMatrix to keep that file
// under the line limit.
export default function ChannelMatrixHead({ channels }: { channels: Channel[] }) {
  return (
    <thead className="bg-muted/40">
      <tr className="border-b border-border">
        <th className="sticky left-0 bg-muted/40 px-2 py-2 text-left z-20" />
        <th className="bg-muted/40 px-2 py-2 w-28" aria-hidden />
        {channels.map((c) => (
          <th
            key={c.id}
            className="px-2 py-2 text-center text-[11px] uppercase tracking-wide font-medium text-foreground"
          >
            {c.name}
          </th>
        ))}
        <th className="sticky right-0 bg-muted/40 px-2 py-2 text-right text-[11px] uppercase tracking-wide font-medium text-foreground z-20 w-32">
          VS Target
        </th>
      </tr>
    </thead>
  )
}
